var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 120,
    viewBox: "0 0 224 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.3818 46.2241H88.6033V58.5862L100.076 46.2241H107.591L96.0771 58.2225L108.116 74.5035H100.642L91.8756 62.4647L88.6033 65.858V74.5033H82.3818V46.2241Z",
    fill: "#131313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.81 63.7977V63.7174C104.81 57.4958 109.819 52.4458 116.566 52.4458C123.272 52.4458 128.241 57.415 128.241 63.6364V63.7174C128.241 69.9388 123.232 74.9884 116.485 74.9884C109.779 74.9884 104.81 70.0193 104.81 63.7977ZM122.181 63.7977V63.7174C122.181 60.5255 119.878 57.7382 116.485 57.7382C112.97 57.7382 110.869 60.4446 110.869 63.6364V63.7174C110.869 66.9088 113.172 69.6962 116.566 69.6962C120.08 69.6962 122.181 66.9896 122.181 63.7977Z",
    fill: "#131313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.936 68.3629V58.1015H127.351V52.8499H129.936V47.315H136.077V52.8497H141.167V58.1015H136.077V67.3531C136.077 68.7668 136.683 69.4539 138.056 69.4539C139.115 69.459 140.158 69.1947 141.086 68.6859V73.6147C139.793 74.3823 138.299 74.8671 136.238 74.8671C132.481 74.8671 129.936 73.3723 129.936 68.3629ZM142.93 45.0122H149.07V74.5034H142.93V45.0122ZM151.29 45.0122H157.754V50.466H151.29V45.0122ZM151.452 52.8497H157.592V74.5034H151.452L151.452 52.8497ZM159.928 52.8497H166.069V55.9199C167.483 54.1019 169.301 52.4457 172.412 52.4457C177.058 52.4457 179.764 55.516 179.764 60.4852V74.5034H173.624V62.4243C173.624 59.5156 172.25 58.0208 169.907 58.0208C167.563 58.0208 166.069 59.5156 166.069 62.4243V74.5034H159.928L159.928 52.8497Z",
    fill: "#131313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1956 46.2095L45 61.1379V74.4835L59.1751 60.2834L73.274 46.2095H59.1956Z",
    fill: "url(#paint0_linear_5274_17766)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74.4837L59.1751 60.2837L73.274 74.4837H45Z",
    fill: "url(#paint1_linear_5274_17766)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 46.2095H59.1956L45 61.1379V46.2095Z",
    fill: "url(#paint2_linear_5274_17766)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5274_17766",
    x1: 40.2398,
    y1: 72.2045,
    x2: 66.5502,
    y2: 45.8939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#C757BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#CD5CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#E8744F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#F88316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5274_17766",
    x1: 54.0236,
    y1: 79.5848,
    x2: 66.8477,
    y2: 66.7605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5274_17766",
    x1: 20.8816,
    y1: 718.647,
    x2: 692.08,
    y2: 80.3962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.02a01a91e488862dea138a4ca9a9c502.svg";
export { ForwardRef as ReactComponent };